<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>

  <form class="form" [formGroup]="conditionEditForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.details | translate }}</li>
        </ul>
      </kt-alert>

      <div class="form-group row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'CONDITION.INPUT.BASIC' | translate }}</h4>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.CODE">Code</mat-label>
            <input
              matInput
              [matAutocomplete]="auto"
              (ngModelChange)="codeInputChanged(codeInput.value)"
              #codeInput
              formControlName="code"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              (optionSelected)="selectedCode($event)"
            >
              <!--  [displayWith]="displayFnCode" -->
              <mat-option *ngFor="let code of filteredCode | async" [value]="code">
                {{ code.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('code', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.CLINICAL_STATUS">Clinical status</mat-label>
            <mat-select formControlName="clinicalStatus">
              <mat-option value="active">Active</mat-option>
              <mat-option value="recurrence">Recurrence</mat-option>
              <mat-option value="relapse">Relapse</mat-option>
              <mat-option value="inactive">Inactive</mat-option>
              <mat-option value="remission">Remission</mat-option>
              <mat-option value="resolved">Resolved</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('clinicalStatus', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.VERIFICATION_STATUS"
              >Verification status</mat-label
            >
            <mat-select formControlName="verificationStatus">
              <mat-option value="unconfirmed">Unconfirmed</mat-option>
              <mat-option value="confirmed">Confirmed</mat-option>
              <mat-option value="refuted">Refuted</mat-option>
              <mat-option value="provisional">Provisional</mat-option>
              <mat-option value="differential">Differential</mat-option>
              <mat-option value="entered-in-error">Entered in Error</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('verificationStatus', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.SEVERITY">severity</mat-label>
            <input
              matInput
              [matAutocomplete]="autoSeverity"
              (ngModelChange)="severityInputChanged(severityInput.value)"
              #severityInput
              formControlName="severity"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoSeverity="matAutocomplete"
              (optionSelected)="selectedSeverity($event)"
            >
              <!--  [displayWith]="displayFnSeverity" -->
              <mat-option *ngFor="let severity of filteredSeverity | async" [value]="severity">
                {{ severity.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('severity', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.BODYSITE">Body Site</mat-label>
            <input
              matInput
              [matAutocomplete]="autoBodySite"
              (ngModelChange)="bodySiteInputChanged(bodySiteInput.value)"
              #bodySiteInput
              formControlName="bodySite"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoBodySite="matAutocomplete"
              (optionSelected)="selectedBodySite($event)"
            >
              <!--  [displayWith]="displayFnBodySite" -->
              <mat-option *ngFor="let bodySite of filteredBodySite | async" [value]="bodySite">
                {{ bodySite.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('bodySite', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <kt-categorys
            [isReadOnly]="isReadOnly"
            [controlObject]="categorys"
            [appearance]="'fill'"
            [value]="categorys$"
          ></kt-categorys>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-condition">
          <h4>{{ 'CONDITION.INPUT.ON_SET' | translate }}</h4>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.ONSET_TYPE">Onset Type</mat-label>
            <mat-select
              formControlName="onset_type"
              #ty
              (ngModelChange)="chooseOnsetType(ty.value)"
            >
              <mat-option value="dateTime">Date</mat-option>
              <mat-option value="string">Text</mat-option>
              <mat-option value="Period">Period</mat-option>
              <mat-option value="Age">Age</mat-option>
              <mat-option value="Range">Range</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('onset_type', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'dateTime'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetDate" formControlName="onsetDate" />
            <mat-datepicker-toggle matSuffix [for]="onsetDate"></mat-datepicker-toggle>
            <mat-datepicker #onsetDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'string'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_STRING' | translate }}</mat-label>
            <input matInput formControlName="onsetString" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_PERIOD_START' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetPeriodStart" formControlName="onsetPeriodStart" />
            <mat-datepicker-toggle matSuffix [for]="onsetPeriodStart"></mat-datepicker-toggle>
            <mat-datepicker #onsetPeriodStart></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_PERIOD_END' | translate }}</mat-label>
            <input matInput [matDatepicker]="onsetPeriodEnd" formControlName="onsetPeriodEnd" />
            <mat-datepicker-toggle matSuffix [for]="onsetPeriodEnd"></mat-datepicker-toggle>
            <mat-datepicker #onsetPeriodEnd></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_AGE' | translate }}</mat-label>
            <input matInput type="number" formControlName="onsetAge" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_AGE_UNIT' | translate }}</mat-label>
            <mat-select formControlName="onsetAgeUnit">
              <mat-option value="a">Year</mat-option>
              <mat-option value="mo">Month</mat-option>
              <mat-option value="wk">Week</mat-option>
              <mat-option value="d">Day</mat-option>
              <mat-option value="h">Hour</mat-option>
              <mat-option value="min">Minutes</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_RANGE_LOW' | translate }}</mat-label>
            <input matInput type="number" formControlName="onsetRangeLow" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="onsetTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ONSET_RANGE_HIGH' | translate }}</mat-label>
            <input matInput type="number" formControlName="onsetRangeHigh" />
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-condition">
          <h4>{{ 'CONDITION.INPUT.ABATEMENT' | translate }}</h4>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.ABATEMENT">Abatement Type</mat-label>
            <mat-select
              formControlName="abatement_type"
              #tye
              (ngModelChange)="chooseAbatementType(tye.value)"
            >
              <mat-option value="dateTime">Date</mat-option>
              <mat-option value="string">Text</mat-option>
              <mat-option value="Period">Period</mat-option>
              <mat-option value="Age">Age</mat-option>
              <mat-option value="Range">Range</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('abatement_type', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'dateTime'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="abatementDate" formControlName="abatementDate" />
            <mat-datepicker-toggle matSuffix [for]="abatementDate"></mat-datepicker-toggle>
            <mat-datepicker #abatementDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'string'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_STRING' | translate }}</mat-label>
            <input matInput formControlName="abatementString" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_PERIOD_START' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="abatementPeriodStart"
              formControlName="abatementPeriodStart"
            />
            <mat-datepicker-toggle matSuffix [for]="abatementPeriodStart"></mat-datepicker-toggle>
            <mat-datepicker #abatementPeriodStart></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Period'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_PERIOD_END' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="abatementPeriodEnd"
              formControlName="abatementPeriodEnd"
            />
            <mat-datepicker-toggle matSuffix [for]="abatementPeriodEnd"></mat-datepicker-toggle>
            <mat-datepicker #abatementPeriodEnd></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_AGE' | translate }}</mat-label>
            <input matInput type="number" formControlName="abatementAge" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Age'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_AGE_UNIT' | translate }}</mat-label>
            <mat-select formControlName="abatementAgeUnit">
              <mat-option value="a">Year</mat-option>
              <mat-option value="mo">Month</mat-option>
              <mat-option value="wk">Week</mat-option>
              <mat-option value="d">Day</mat-option>
              <mat-option value="h">Hour</mat-option>
              <mat-option value="min">Minutes</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_RANGE_LOW' | translate }}</mat-label>
            <input matInput type="number" formControlName="abatementRangeLow" />
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="abatementTypeOption == 'Range'">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.ABATEMENT_RANGE_HIGH' | translate }}</mat-label>
            <input matInput type="number" formControlName="abatementRangeHigh" />
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-condition">
          <h4>{{ 'CONDITION.INPUT.RECORDING' | translate }}</h4>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.RECORDED_DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="recordedDate" formControlName="recordedDate" />
            <mat-datepicker-toggle matSuffix [for]="recordedDate"></mat-datepicker-toggle>
            <mat-datepicker #recordedDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile"></div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.RECORDER_TYPE">Recorder Type</mat-label>
            <mat-select
              formControlName="recorderResourceType"
              #t
              (ngModelChange)="choseRecorderType(t.value)"
            >
              <mat-option value="Patient">Patient</mat-option>
              <mat-option value="Practitioner">Practitioner</mat-option>
              <mat-option value="RelatedPerson">Related person</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('recorderResourceType', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.ASSERTER_TYPE">Asserter Type</mat-label>
            <mat-select
              formControlName="asserterType"
              #ts
              (ngModelChange)="chooseAsserterType(ts.value)"
            >
              <mat-option value="Patient">Patient</mat-option>
              <mat-option value="Practitioner">Practitioner</mat-option>
              <mat-option value="RelatedPerson">Related person</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('asserterType', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field
            appearance="fill"
            class="mat-form-field-fluid"
            *ngIf="recorderOption != ''"
          >
            <mat-label translate="CONDITION.INPUT.RECORDER">recorder</mat-label>
            <input
              matInput
              [matAutocomplete]="autoRecorder"
              (ngModelChange)="recorderInputChanged($event, t.value)"
              #recorderInput
              formControlName="recorder"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoRecorder="matAutocomplete"
              (optionSelected)="selectedRecorder($event)"
              [displayWith]="displayFnRecorder"
            >
              <mat-option *ngFor="let recorder of filteredRecorder | async" [value]="recorder">
                {{ getName(recorder, t.value) }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('recorder', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-6 kt-margin-bottom-20-mobile">
          <mat-form-field
            appearance="fill"
            class="mat-form-field-fluid"
            *ngIf="asserterOption != ''"
          >
            <mat-label translate="CONDITION.INPUT.ASSERTER">Asserter</mat-label>
            <input
              matInput
              [matAutocomplete]="autoAsserter"
              (ngModelChange)="asserterInputChanged($event, ts.value)"
              #asserterInput
              formControlName="asserter"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoAsserter="matAutocomplete"
              (optionSelected)="selectedAsserter($event)"
              [displayWith]="displayFnAsserter"
            >
              <mat-option *ngFor="let asserter of filteredAsserter | async" [value]="asserter">
                {{ getName(asserter, ts.value) }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('asserter', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>{{ 'CONDITION.INPUT.NOTE' | translate }}</mat-label>
            <textarea matInput formControlName="note" rows="4"></textarea>
            <mat-error *ngIf="isControlHasError('note', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile headers-in-post-condition">
          <h4>{{ 'CONDITION.INPUT.REACTION' | translate }}</h4>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.SUMMARY">Summary</mat-label>
            <input
              matInput
              [matAutocomplete]="autoSummary"
              (ngModelChange)="summaryInputChanged(summaryInput.value)"
              #summaryInput
              formControlName="summary"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoSummary="matAutocomplete"
              (optionSelected)="selectedSummary($event)"
            >
              <!--  [displayWith]="displayFnSummary" -->
              <mat-option *ngFor="let summary of filteredSummary | async" [value]="summary">
                {{ summary.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('summary', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.TYPE">Type</mat-label>
            <input
              matInput
              [matAutocomplete]="autoType"
              (ngModelChange)="typeInputChanged(typeInput.value)"
              #typeInput
              formControlName="type"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoType="matAutocomplete"
              (optionSelected)="selectedType($event)"
            >
              <!--  [displayWith]="displayFnType" -->
              <mat-option *ngFor="let type of filteredType | async" [value]="type">
                {{ type.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('type', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="CONDITION.INPUT.EVIDENCE">Evidence</mat-label>
            <input
              matInput
              [matAutocomplete]="autoEvidence"
              (ngModelChange)="evidenceInputChanged(evidenceInput.value)"
              #evidenceInput
              formControlName="evidence"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              autoActiveFirstOption
              #autoEvidence="matAutocomplete"
              (optionSelected)="selectedEvidence($event)"
            >
              <!--  [displayWith]="displayFnEvidence" -->
              <mat-option *ngFor="let evidence of filteredEvidence | async" [value]="evidence">
                {{ evidence.concept.fsn.term }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('evidence', 'required')">
              {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            *ngIf="!isReadOnly"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
